import { creditorConstants } from '../../../constants';

export const validate = values => {
  const errors = {};

  return errors;
};
